document.addEventListener(
	'alpine:init',
	bootstrap
);

export default() => ({
	id: null,
	visible: false,
	init() {
		this.id = this.$el.attributes.id.value;
	},
	onShowSection() {
		this.visible = this.id === this.$event.detail;
	}
});

function bootstrap() {
	document.querySelectorAll('.js-legal-section').forEach(
		$section => bootstrapSection($section)
	);
}

function bootstrapSection($section) {
	$section.setAttribute('x-data', 'legalSection');
	$section.setAttribute('x-cloak', '');
	$section.setAttribute('x-show', 'visible');
	$section.setAttribute('x-on:show-section.window', 'onShowSection');
}
